// src/slices/notifications/types.ts
// Theo LMS-APP/cmsapp-service/.features/notification-list/api-design.md

export enum NotificationType {
  Confirmation = 1, // Xác nhận
  Urgent = 2,       // Khẩn cấp
  Warning = 3,      // Cảnh báo
  Info = 4,         // Thông tin
  Request = 5,      // Yêu cầu
}

export enum NotificationPriority {
  Low = 1,
  Normal = 2,
  High = 3,
  Urgent = 4,
}

export interface NotificationItem {
  id: number | string;
  title: string;
  content: string;
  type: NotificationType;
  typeName: string;
  sender: string | null;
  senderId: number | string | null;
  link: string | null;
  isRead: boolean;
  readAt: string | null;
  priority: NotificationPriority;
  expiresAt?: string | null;
  createdAt: string;
}

export interface NotificationsState {
  items: NotificationItem[];
  unreadCount: number;
  totalCount: number;
  loading: boolean;
  error: string | null;
}
